module.exports = __webpack_public_path__ + "static/media/carousel_02.4192e9dd.gif";